import React from 'react';
import styled from 'styled-components';

const Label = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: ${({ theme }) => theme.fonts.mono};
  font-size: 10px;
  letter-spacing: 0.4em;
  color: ${({ theme }) => theme.colors.blue};
  text-transform: uppercase;
  margin-bottom: 18px;

  &::before {
    content: '';
    width: 28px;
    height: 1px;
    background: ${({ theme }) => theme.colors.blue};
    flex-shrink: 0;
  }
`;

export default function SectionLabel({ children }) {
  return <Label>{children}</Label>;
}
